import { z } from 'zod';
import { ReferralFormSchema } from '../referralFormSchema';

export const selectedCustomerAccountHiddenFields = [
  'customerProfile.name',
  'customerProfile.address.addressLine1',
  'customerProfile.address.city',
  'customerProfile.address.country',
  'customerProfile.address.postalCode',
  'customerProfile.address.region',
  'customerProfile.isMatchingComplete',
  'customerProfile.isMaccEligible',
  'customerProfile.ids[0].id',
  'customerProfile.ids[0].profileType',
] as const;

export enum FieldEnum {
  'customerProfile.team' = 'customerProfile.team',
}

/** Customer details section schemas */

export const SelectedCustomerAccountSchema =
  ReferralFormSchema.shape.customerProfile.pick({
    name: true,
    address: true,
    isMatchingComplete: true,
    isMaccEligible: true,
    ids: true,
  });

export type SelectedCustomerAccountType = z.infer<
  typeof SelectedCustomerAccountSchema
>;

export const CustomerDetailsSectionSchema = SelectedCustomerAccountSchema.merge(
  ReferralFormSchema.shape.customerProfile.pick({
    team: true,
  }),
);

export type CustomerProfileFields = z.infer<
  typeof CustomerDetailsSectionSchema
>;

/** Customer lookup drawer schema */

export const CustomerAddressSchema = z.object({
  addressLine1: z.string().optional(),
  addressLine2: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  region: z.string().optional(),
  postalCode: z.string().optional(),
  country: z.string().optional(),
});

/** Customer Lookup Input */
export const CustomerLookupPayloadSchema = z
  .object({
    companyName: z.string().optional(),
    address: CustomerAddressSchema.optional(),
  })
  .optional();

export type CustomerLookupPayloadType = z.input<
  typeof CustomerLookupPayloadSchema
>;
